import * as React from 'react';
import { MdDarkMode, MdLightMode } from 'react-icons/md';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useColorScheme } from '@mui/material/styles';
import { colorSchemes } from './theme';
import { getItem, setItem } from '@utils/localStorage';

export default function ColorModeIconDropdown() {
  const { mode, systemMode, setMode } = useColorScheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  React.useLayoutEffect(() => {
    let th = getItem('theme');
    if (th) handleMode(th);
  }, []);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMode = (targetMode: 'system' | 'light' | 'dark') => () => {
    setMode(targetMode);
    setItem('theme', targetMode);
    handleClose();
  };

  if (!mode) {
    return (
      // @ts-ignore - ignore the app-region error its not in native css but is added by electron
      <Box
        className="size-full aspect-square"
        data-screenshot="toggle-mode"
        style={{ 'app-region': 'no-drag', '-webkit-app-region': 'no-drag' }}
        sx={(theme) => ({
          border: '1px solid',
          // @ts-ignore
          borderColor: (theme.vars || theme).palette.divider,
          // @ts-ignore
          borderRadius: (theme.vars || theme).shape.borderRadius,
          display: 'inline-flex',
          verticalAlign: 'bottom',
        })}
      />
    );
  }
  const resolvedMode = (systemMode || mode) as 'light' | 'dark';
  const icon = {
    dark: <MdDarkMode className="size-full" />,
    light: <MdLightMode className="size-full" />,
  }[resolvedMode];
  return (
    <>
      <div
        onClick={handleClick}
        className="!size-full aspect-square !p-0 flex items-center justify-center"
        // @ts-ignore - same as above
        style={{ 'app-region': 'no-drag', '-webkit-app-region': 'no-drag' }}
      >
        {icon}
      </div>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        className="mt-2"
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              my: '4px',
            },
            variant: 'outlined',
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem selected={mode === 'system'} onClick={handleMode('system')}>
          System
        </MenuItem>
        <MenuItem selected={mode === 'light'} onClick={handleMode('light')}>
          Light
        </MenuItem>
        <MenuItem selected={mode === 'dark'} onClick={handleMode('dark')}>
          Dark
        </MenuItem>
      </Menu>
    </>
  );
}
